import type React from 'react'
import type { TextAligning } from 'atoms/TextBox'

import { Icon, IconNames, IconSizes } from 'atoms/Icon'
import { TextBlockPopupMention } from 'blocks/TextBlock/Templates'
import { COLOR, FIXED_INDENTS } from 'vars/index'
import {
  CircleWrapperIcon,
  PaymentMentionPopupSC,
} from './PopupComponents.styled'

export interface IPaymentMentionPopup {
  children?: React.ReactNode
  columnGap?: FIXED_INDENTS
  rowGap?: FIXED_INDENTS
  title: string
  description: string
  errorPayment?: boolean
  textAlignment?: TextAligning
}

export const PaymentMentionPopup = ({
  rowGap = FIXED_INDENTS.INDENT_60,
  children,
  title,
  description,
  errorPayment,
  textAlignment,
}: IPaymentMentionPopup) => {
  const conditionIcon = errorPayment ? IconNames.close : IconNames.check

  return (
    <PaymentMentionPopupSC rowGap={rowGap}>
      <CircleWrapperIcon errorPayment={errorPayment}>
        <Icon
          name={conditionIcon}
          size={IconSizes.medium}
          color={COLOR.TEXT_ICON_CONSTANT_LIGHT}
        />
      </CircleWrapperIcon>
      <TextBlockPopupMention
        alignment={textAlignment}
        title={title}
        description={description}
      />
      {children}
    </PaymentMentionPopupSC>
  )
}
